import camelCase from 'to-camel-case';
var namespacer = '/';
export default (function (type) {
  return type.includes(namespacer) ? type.split(namespacer).map(camelCase).join(namespacer) : camelCase(type);
});